import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link } from "react-router-dom";

function OffCanvasStyleOne() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="side-content-button">
        <Link
          to="#"
          variant="primary"
          className="navSidebar-button"
          onClick={handleShow}
        >
          <span className="decor"></span>
          <span className="decor"></span>
          <span className="decor"></span>
        </Link>

        <Offcanvas
          show={show}
          onHide={handleClose}
          className="xs-sidebar-group info-group info-sidebar isActive"
        >
          <div className="xs-overlay xs-bg-black"></div>
          <div className="xs-sidebar-widget">
            <div className="sidebar-widget-container">
              <Offcanvas.Header
                closeButton
                className="close-side-widget"
              ></Offcanvas.Header>
              <div className="sidebar-textwidget">
                <div className="sidebar-info-contents">
                  <div className="content-inner">
                    <div className="logo">
                      <Link to="/">
                        <img
                          style={{ width: "180px" }}
                          src="/assets/images/resources/nazar_logo.png"
                          alt=""
                        />
                      </Link>
                    </div>
                    <div className="content-box">
                      <h4>About Us</h4>
                      <div className="inner-text">
                        <p>
                          We are suppliers of Marine & Industrial Machinery,
                          Spares, Automation Systems, and Electronic Equipment.
                          At Nazar Enterprise & Co., we are committed to
                          delivering high-quality products and reliable
                          solutions for all your marine and industrial
                          requirements. With extensive experience in the
                          ship-recycling and industrial sectors, we ensure that
                          every product meets professional standards and
                          customer expectations.
                        </p>
                      </div>
                    </div>

                    {/* <div className="form-inner">
                      <h4>Get a free quote</h4>
                      <form action="index.html" method="post">
                        <div className="form-group">
                          <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            required=""
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            required=""
                          />
                        </div>
                        <div className="form-group">
                          <textarea
                            name="message"
                            placeholder="Message..."
                          ></textarea>
                        </div>
                        <div className="form-group message-btn">
                          <button
                            className="thm-btn"
                            data-text="Submit Now +"
                            type="submit"
                            data-loading-text="Please wait..."
                          >
                            Submit Now
                          </button>
                        </div>
                      </form>
                    </div> */}

                    <div className="sidebar-contact-info">
                      <h4>Contact Info</h4>
                      <ul>
                        <li>
                          <span className=" icon-maps-and-flags"></span>
                          Bhavnagar, Gujarat
                        </li>
                        <li>
                          <span className="icon-phone-call-1"></span>
                          <a href="tel:123456789">
                            +91 9409072990 <br></br> +91 8140702552
                          </a>
                        </li>
                        <li>
                          <span className="icon-email-1"></span>
                          <a href="mailto:info@example.com">sales@nazarenterprise.com</a>
                        </li>
                      </ul>
                    </div>
                    <div className="thm-social-link1">
                      <ul className="social-box">
                        <li className="facebook">
                          <a href="https://facebook.com">
                            <i
                              className="icon-facebook-app-symbol"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                        <li className="twitter">
                          <a href="https://twitter.com">
                            <i className="icon-twitter" aria-hidden="true"></i>
                          </a>
                        </li>
                        <li className="linkedin">
                          <a href="https://linkedin.com">
                            <i className="icon-linkedin" aria-hidden="true"></i>
                          </a>
                        </li>
                        <li className="gplus">
                          <a href="https://google.com">
                            <i
                              className="icon-google-plus-logo"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas>
      </div>
    </>
  );
}

export default OffCanvasStyleOne;
